import Promise from 'promise-polyfill';

/**
 * Dynamically loads a JavaScript file by appending a script tag to the document body.
 * Skips loading if the script is already present in the DOM.
 *
 * @param {string} url - The URL of the script to load
 * @param {boolean} [useDefer=false] - Whether to set the defer attribute
 * @param {boolean} [useAsync=false] - Whether to set the async attribute
 * @returns {Promise<void>} Resolves when the script has loaded
 */
function loadScript(url, useDefer = false, useAsync = false) {
	if (document.querySelector(`script[src="${url}"]`)) {
		return Promise.resolve();
	}
	/* Wire up response promise */
	let resolveCB;
	const resultPromise = new Promise((resolve, reject) => {
		resolveCB = resolve;
	});
	/* Create tag and append to the body */
	const scriptTag = document.createElement('script');
	scriptTag.src = url;
	scriptTag.onload = resolveCB;
	if (useDefer) { scriptTag.defer = useDefer; }
	if (useAsync) { scriptTag.async = useAsync; }
	document.body.appendChild(scriptTag);
	return resultPromise;
}

export default loadScript;
